/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="bcm-whole-header">
    <header class="block-navigation" :class="[classValue]">
      <div class="main-navigation" ref="navigationAncor">
        <div class="middle-navigation">
          <b-row class="align-items-center no-gutters">
            <b-col class="left-block text-left">
              <!-- placeholder for components who want to write here -->
              <span class="jq-back"></span>
              <h1 class="page-title">{{ $t(pageTitle) }}</h1>
            </b-col>
            <b-col class="right-block">
              <right-block-nav />
            </b-col>
          </b-row>
        </div>
        <div class="bottom-navigation">
          <div class="wrapp-ctas">
            <div class="wrapp-search-right">
              <search-filter />
            </div>
            <div class="wrapp-button">
              <button class="btn btn-none wrapp-current-store" type="button">
                <div class="wrapp-icon">
                  <svg class="o-icon"><use xlink:href="#shop"></use></svg>
                </div>
                <div class="store-info">
                  <span>{{currentAddress}}</span>
                </div>
              </button>
            </div>
          </div>
          <div class="wrapp-breadcrumb">
            <breadcrumb :items="pathBreadcrumb" />
            <portal-target name="nav-bottom" :key="pageTitle + $route.fullPath" />
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import Config from 'config'
import { mapGetters } from 'vuex'
import { getLocalizedByUrl } from '@/helpers/routeHelpers'
import Breadcrumb from 'theme/components/Breadcrumb/Breadcrumb'
import RightBlockNav from 'theme/components/Header/RightBlock/RightBlockNav'
import SearchFilter from 'theme/components/Listing/SearchFilter'

export default {
  props: {
    classValue: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      Config: Config,
      navSearch: ''
    }
  },
  computed: {
    ...mapGetters({
      pageTitle: 'ui/getHeaderPageTitle',
      currentAddress: 'userAdmin/getCurrentAddress',
      isOnlineMode: 'userAdmin/getOnlineMode'
    }),
    pathBreadcrumb () {
      let paths = []
      paths.push({
        text: this.$t('all-categories'),
        to: { name: 'home', params: { lang: this.$store.state.ui.storeViewCode } },
        active: false
      })
      this.$store.getters['category/breadcrumbs'].forEach(bread => {
        paths.push({
          text: bread.category_name,
          to: getLocalizedByUrl(this.$store.state.ui.urlCode, `${bread.category_url_path}${this.$store.state.storeConfig.config.category_url_suffix}?id=${bread.category_id}`),
          active: false
        })
      })
      if (this.$store.state.category.current && this.$store.state.category.current.name) {
        paths.push({
          text: this.$store.state.category.current.name,
          active: true
        })
      }
      return paths
    }
  },
  methods: {
    // disabled by CN-157
    // changeStore () {
    //   const componentToLoad = import('theme/components/ChangeStore/ChangeStore')
    //   this.$store.dispatch('ui/loadGenericModalComponent', { title: 'select-store-to-browse', component: componentToLoad, modalProps: { hideFooter: true } })
    // }
  },
  mounted () {
    if (process.client) {
      this.hideTopNotification = global.$cookies.get('hide-top-banner-badge')
    }
  },
  components: {
    RightBlockNav,
    Breadcrumb,
    SearchFilter
  }
}
</script>
